/* eslint-disable security/detect-object-injection */
/* eslint-disable max-len */
// idSlice.js
import { createSlice ,createSelector, current} from '@reduxjs/toolkit';
import { selectStudentsList } from '../attendanceSlice';
import attendanceReducer from '../attendanceSlice'

const getAttendanceRowId = (item) => (
    window.location.pathname === "/employee-master/employee-attendance"
        ? (item?.employee_id)
        : item?.student_id
);

const getSortableIdSuffix = (id) => String(id || '').slice(-4);

const initialState={
    selectedRows:{
        studentId:[],
        topCheckBox:[],
        
    }
    
}
const idSlice = createSlice({
    name: 'selectedRows',
    initialState: initialState,
    reducers: {
        toggleRowSelection: (state, action) => {
            
            //studentid,pagenumber,limit,recodes.length,recodes
            const indexToUpdate = state.selectedRows.studentId.findIndex((stuId) => stuId.id === action.payload[0]);
            const pagenumberObj=state.selectedRows.studentId.find(obj=>obj.id===action.payload[0])
            // const pageNUmberToCheck=pagenumberObj?.pageNumber
            if (indexToUpdate !== -1) {
                // If an object with the same 'id' exists, remove it
                state.selectedRows.studentId.splice(indexToUpdate, 1);
                if(state.selectedRows.topCheckBox.some((obj)=>obj.page_number===action.payload[1])){

                    const foundObj=state.selectedRows.topCheckBox.find((obj) => obj.page_number === action.payload[1]);

                    if (foundObj) {
                        // Modify the object's properties
                        foundObj.isChecked = false;
                    }
                }
                
            }
            else{
            // Add the new object to the array
                state.selectedRows.studentId.push({id:action.payload[0],pageNumber:action.payload[1]});
                // const count = state.selectedRows.studentId.reduce((accumulator, currentObject) => {
                //     // Check if the current object has the desired category
                //     if (currentObject.pageNumber === action.payload[1]) {
                //         accumulator++;
                //     }
                //     return accumulator;
                // }, 0);
                state.selectedRows.studentId.sort((a, b) =>
                    getSortableIdSuffix(a.id).localeCompare(getSortableIdSuffix(b.id))
                );
                const filteredArray = state.selectedRows.studentId.filter(obj1 =>
                    action.payload[4].some(obj2 => getAttendanceRowId(obj2) === obj1.id )
                );
                const count=filteredArray.length
                if(count==parseInt(action.payload[3])){
                    
                    const foundObj=state.selectedRows.topCheckBox.find((obj) => obj.page_number === action.payload[1]);
                    if(!foundObj){
                        state.selectedRows.topCheckBox.push({page_number:action.payload[1], isChecked:true,limit:action.payload[2] });
                    }
                    else{
                        foundObj.isChecked=true
                    }
                }

            }
            

        },
        selectAllStudents:(state,action)=>{
            if(action?.payload?.length===3 && state?.selectedRows?.topCheckBox?.length>0){
                const limit = action.payload[0]
                const prevLimit=action.payload[1]
                const ListCount=action.payload[2].total_count
                
                const pageNum="1"
                const count = state.selectedRows.studentId.reduce((accumulator, obj) => {
                    if (obj.pageNumber === pageNum) {
                        return accumulator + 1;
                    }
                    return accumulator;
                }, 0);
                const pageNumbersToProcess = state.selectedRows.studentId.reduce((unique, obj) => {
                    if (!unique.includes(obj.pageNumber)) {
                        unique.push(obj.pageNumber);
                    }
                    return unique;
                }, []);
                
                pageNumbersToProcess.forEach(pageNum=>{
                    const count2 = state.selectedRows.studentId.reduce((accumulator, obj) => {
                        if (obj.pageNumber === pageNum) {
                            return accumulator + 1;
                        }
                        return accumulator;
                    }, 0);
                    const objectToUpdatebeg=state.selectedRows.topCheckBox.find((checkbx)=>checkbx.page_number===pageNum)
                    if(objectToUpdatebeg){
                        if(count2===parseInt(limit) && parseInt(limit)<=parseInt(ListCount)){
                            objectToUpdatebeg.isChecked=true
                            objectToUpdatebeg.limit=limit
    
                        
                        }
                        else if(parseInt(limit)>parseInt(ListCount)){
                            if(count===parseInt(ListCount)){
                                objectToUpdatebeg.isChecked=true
                                objectToUpdatebeg.limit=limit
                            }
                        }
                        else{
                            objectToUpdatebeg.isChecked=false
                            objectToUpdatebeg.limit=limit
                        }
                    }
                    
                
                })
                
                const objectToUpdate=state.selectedRows.topCheckBox.find((checkbx)=>checkbx.page_number===pageNum &&checkbx.isChecked===true)
                
                if(objectToUpdate&& objectToUpdate.limit!==limit){
                    objectToUpdate.isChecked=false
                    objectToUpdate.limit=limit
                    
                    if(count!==parseInt(limit)){
                        state.selectedRows.topCheckBox=[]
                        const sourceIds = action.payload[2]?.student_ids || action.payload[2]?.employee_ids || [];
                        const remstudentids=parseInt(sourceIds.length)%parseInt(limit)
                        function distributeStudentIds(arrayOfObjects, limit,first_id) {
                        
                            let first_stuid=parseInt(String(first_id || '').slice(-4))
                            const numberOfPages = Math.ceil(arrayOfObjects.length / limit);
                            const studentsPerPage = limit
                          
                            let currentPage = 1;
                            let studentsAssigned = 0;
                            let studentrem=0
                            let tempcount=0
                            arrayOfObjects.forEach((obj) => {
                                if (studentsAssigned === parseInt(studentsPerPage)) {
                                    const foundObj=state.selectedRows.topCheckBox.find((obj) => obj.page_number === currentPage.toString());
                                    //const tempcount=state.selectedRows.studentId.filter(student => student.pageNumber === currentPage.toString()).length
    
                                    if(!foundObj && tempcount===parseInt(studentsPerPage)){
                                        state.selectedRows.topCheckBox.push({page_number:currentPage.toString(), isChecked:true,limit:limit });
                                    }
                                    else if (!foundObj && tempcount!==parseInt(studentsPerPage)){
                                        state.selectedRows.topCheckBox.push({page_number:currentPage.toString(), isChecked:false,limit:limit })
                                    } 
                                    if(foundObj && tempcount===parseInt(studentsPerPage)){
                                        foundObj.isChecked=true
                                        foundObj.limit=limit
                                    }
                                    else if(foundObj && tempcount!==parseInt(studentsPerPage )){
                                        foundObj.isChecked=false
                                        foundObj.limit=limit
                                    }
                                    currentPage++;
                                    studentsAssigned = 0;
                                    tempcount=0
                                }
                                
                                tempcount++
                                
                                if(parseInt(getSortableIdSuffix(obj?.id))===first_stuid){
                                    first_stuid++;
                                    studentsAssigned++
                                }
                                else{
                                    while(true){
                                        if(parseInt(getSortableIdSuffix(obj?.id))!==first_stuid){
                                            if (studentsAssigned === parseInt(studentsPerPage)) {
                                                currentPage++
                                                studentsAssigned=1
                                            }
                                            studentsAssigned++;
                                            first_stuid++
                                        }
                                        else{
                                            studentsAssigned++
                                            first_stuid++
                                            break;
                                        }
                                    }
                                }
                                obj.pageNumber = currentPage.toString();
                                
                                
                          
                                
                            });
                            if(!state.selectedRows.topCheckBox.some((obj)=>obj.page_number===currentPage.toString())){
                                state.selectedRows.topCheckBox.push({page_number:currentPage.toString(), isChecked:false,limit:limit });
    
                            }
                            if(remstudentids>0){
                                const lastStudentIds=state.selectedRows.studentId.filter((obj)=>obj.pageNumber===currentPage.toString())
                                if(lastStudentIds.length===remstudentids){
                                    const foundObj= state.selectedRows.topCheckBox.find((obj)=>obj.page_number===currentPage.toString())
                                    if(foundObj){
                                        foundObj.isChecked=true
                                    }
                                   
                                }
    
                            }
                        }
                          
                        distributeStudentIds(state.selectedRows.studentId, limit,sourceIds[0]);    
                        
                    }
                    else{
                        {objectToUpdate?objectToUpdate.isChecked=true:""}
                    }
                      
                }
                else{
                    // state.selectedRows.studentId=state.selectedRows.studentId.map((obj,index)=>({
                    //     ...obj,
                    //     pageNumber:"1"

                    // }))
                    const sourceIds = action.payload[2]?.student_ids || action.payload[2]?.employee_ids || [];
                    const remstudentids=parseInt(sourceIds.length)%parseInt(limit)
                    function distributeStudentIds(arrayOfObjects, limit,first_id) {
                        let first_stuid=parseInt(String(first_id || '').slice(-4))
                        const numberOfPages = Math.ceil(arrayOfObjects.length / limit);
                        const studentsPerPage = limit
                      
                        let currentPage = 1;
                        let studentsAssigned = 0;
                        let studentrem=0
                        let tempcount=0
                        arrayOfObjects.forEach((obj) => {
                            if (studentsAssigned === parseInt(studentsPerPage)) {
                                
                                const foundObj=state.selectedRows.topCheckBox.find((obj) => obj.page_number === currentPage.toString());
                                //const tempcount=state.selectedRows.studentId.filter(student => student.pageNumber === currentPage.toString()).length
                                if(!foundObj && tempcount===parseInt(studentsPerPage)){
                                    state.selectedRows.topCheckBox.push({page_number:currentPage.toString(), isChecked:true,limit:limit });
                                }
                                else if(!foundObj && tempcount!==parseInt(studentsPerPage)){
                                    state.selectedRows.topCheckBox.push({page_number:currentPage.toString(), isChecked:false,limit:limit })
                                } 
                                if(foundObj && tempcount===parseInt(studentsPerPage)){
                                    foundObj.isChecked=true
                                    foundObj.limit=limit
                                }
                                else if(foundObj && tempcount!==parseInt(studentsPerPage )){
                                    foundObj.isChecked=false
                                    foundObj.limit=limit
                                }
                                currentPage++;
                                studentsAssigned = 0;
                                tempcount=0
                            }
                            
                            tempcount++
                            if(parseInt(String(obj?.id || '').slice(-4))===first_stuid){
                                first_stuid++;
                                studentsAssigned++
                            }
                            else{
                
                                while(true){
                                    if(parseInt(String(obj?.id || '').slice(-4))!==first_stuid){
                                        
                                        
                                        if (studentsAssigned === parseInt(studentsPerPage)) {
                                            currentPage++
                                            studentsAssigned=1
                                        }
                                        studentsAssigned++;
                                        first_stuid++
                                    }
                                    else{
                                        studentsAssigned++
                                        first_stuid++
                                        break;
                                    }
                                    
                                }
                            }
                            obj.pageNumber = currentPage.toString();
                            
                            
                      
                            
                        });
                        if(!state.selectedRows.topCheckBox.some((obj)=>obj.page_number===currentPage.toString())){
                            state.selectedRows.topCheckBox.push({page_number:currentPage.toString(), isChecked:false,limit:limit });

                        }
                        if(remstudentids>0){
                            const lastStudentIds=state.selectedRows.studentId.filter((obj)=>obj.pageNumber===currentPage.toString())
                            if(lastStudentIds.length===remstudentids){
                                const foundObj= state.selectedRows.topCheckBox.find((obj)=>obj.page_number===currentPage.toString())
                                if(foundObj){
                                    foundObj.isChecked=true
                                }
                                   
                            }
    
                        }
                    }
                      
                    distributeStudentIds(state.selectedRows.studentId, limit,sourceIds[0]);
                    const pageNumbersFirstArray = state.selectedRows.studentId.map(obj => obj.pageNumber);
                    const pageNumbersSecondArray = state.selectedRows.topCheckBox.map(obj => obj.page_number);
                    //const uniquePageNumbers = pageNumbersFirstArray.filter(pageNum => !pageNumbersSecondArray.includes(pageNum));
                    const uniquePageNumbers=pageNumbersFirstArray
                    uniquePageNumbers.forEach(pageNum => {
                        const count = pageNumbersFirstArray.filter(page => page === pageNum).length;
                        if (count >= parseInt(limit)) {
                            // Find the object in the second array with the matching page number and set isChecked to true
                            const matchingObject = state.selectedRows.topCheckBox.find(obj => obj.page_number === pageNum);
                            if (matchingObject) {
                                matchingObject.isChecked = true;
                            }
                            else{
                                state.selectedRows.topCheckBox.push({page_number:pageNum, isChecked:true,limit:limit });
                            }
                        }
                    });
                    
                }
                return
            }
            if(action?.payload?.length===4)
            {
                const isChecked=action.payload[0]
                const studentsPerPage=action.payload[1]
                
                const pageNumber=action.payload[2]
                
                const limit=action.payload[3]
                if(isChecked)
                {
                    const objectToUpdate=state.selectedRows.topCheckBox.find((checkbx)=>checkbx.page_number===pageNumber)
                    if(objectToUpdate){
                        objectToUpdate.isChecked=true
                    }
                    else{
                        state.selectedRows.topCheckBox.push({page_number:pageNumber,isChecked:true,limit:limit})
                    }
                    // Use the `some()` method to check if an object with the same `id` exists in the target array
                    const filteredObjectsToAdd = studentsPerPage.filter((newObj) => {
                        return !state.selectedRows.studentId.some((existingObj) => existingObj.id === newObj.id);
                    });
  
                    // Concatenate the filtered objects to the target array
                    state.selectedRows.studentId = state.selectedRows.studentId.concat(filteredObjectsToAdd);
                    state.selectedRows.studentId.sort((a, b) =>
                        getSortableIdSuffix(a.id).localeCompare(getSortableIdSuffix(b.id))
                    );

                }
                else{
                //state.selectedRows.studentId= state.selectedRows.studentId.filter((obj)=>obj.pageNumber!==action.payload[2])
                    const foundObject = state.selectedRows.topCheckBox.find((obj) => obj.page_number === pageNumber);
                    if (foundObject) {
                    // Modify the object's properties
                        foundObject.isChecked = false;
                        state.selectedRows.studentId = state.selectedRows.studentId.filter(obj => !studentsPerPage.some(firstObj => firstObj.id === obj.id));

                        //state.selectedRows.studentId=state.selectedRows.studentId.filter(obj=>obj)
                        // let filteredArray = state.selectedRows.studentId.filter(obj => obj.pageNumber === pageNumber);
                        // // Check if there are objects with the specific pageNumber
                        
                        // // Use splice() to remove matching objects from the original array
                        // const filteredArray2 = filteredArray.filter(obj => {
                        //     return !studentsPerPage.some(idObj => idObj.id === obj.id && idObj.pageNumber === obj.pageNumber);
                        // });
                        
                        // state.selectedRows.studentId = state.selectedRows.studentId.filter(obj => obj.pageNumber !== pageNumber);

                        // // Use splice() again to remove the last n objects from the filtered array
                        // // Concatenate the filteredArray back to the original arrayOfObjects
                        // state.selectedRows.studentId = state.selectedRows.studentId.concat(filteredArray2);

                        // Now, arrayOfObjects will have objects with the specific pageNumber,
                        // and objects with specific IDs and matching pageNumber removed
                    } 
                    //state.selectedRows.studentId=state.selectedRows.studentId.splice(-(parseInt(studentsPerPage.length)))
                    else {
                        
                    }
                }
            }
        }
            
        ,
        removeRow:(state,action)=>{
            const indexToUpdate = state.selectedRows.studentId.findIndex((stuId) => stuId.id === action.payload);
            if (indexToUpdate !== -1) {
                
                // If an object with the same 'id' exists, remove it
                state.selectedRows.studentId.splice(indexToUpdate, 1);
                
            }
        },
        addRow:(state,action)=>{
            state.selectedRows.studentId.push({pageNumber:"searchadd",id:action.payload});
            state.selectedRows.studentId.sort((a, b) =>
                getSortableIdSuffix(a.id).localeCompare(getSortableIdSuffix(b.id))
            );
        },
        onSearchRows:(state,action)=>{
            const searchStr=action.payload[0]
            const searchArray=action.payload[1]
            //const page_number=action.payload[2]
            
            const foundObject = state?.selectedRows?.topCheckBox?.find((obj) => obj.page_number === action.payload[2]);
            if (searchStr!==""&&searchStr!==null&&action.payload.length===3) {
                // Modify the object's properties
                const areAllIncluded = searchArray.every((secondObj) =>
                    state.selectedRows.studentId.some((firstObj) => firstObj.id === getAttendanceRowId(secondObj))
                );
                if(!areAllIncluded &&(foundObject)){
                    foundObject.isChecked = false;
                }
                else{
                    foundObject?foundObject.isChecked=true:""
                }
                //state.selectedRows.studentId=state.selectedRows.studentId.map((obj)=>({...obj,pageNumber:action.payload[2]}))
                
            }
            if((searchStr===""||searchStr===null)&&action.payload.length===4){
                const limit=parseInt(action.payload[2])
                //state.selectedRows.studentId=state.selectedRows.studentId.map((obj)=>({id:obj.id,pageNumber:Math.ceil(parseInt(obj?.id?.slice(-4))/parseInt(action.payload[2])).toString()}))
                // if( state.selectedRows.studentId.filter((obj) => obj.pageNumber === action.payload[3]).length===parseInt(action.payload[2])){

                //     // if(!foundObject.isChecked)
                //     // {
                //     //     foundObject.isChecked = true
                //     // }
                //     const existingObjectIndex = state.selectedRows.topCheckBox.findIndex(obj => obj.page_number === action.payload[3]);

                //     if (existingObjectIndex !== -1) {
                //         // If an object with the same page number exists, modify it
                //         state.selectedRows.topCheckBox[existingObjectIndex] = { ...state.selectedRows.topCheckBox[existingObjectIndex], ...isChecked=true };
                //     } else {
                //         // If no object with the same page number exists, add the new object to the array
                //         state.selectedRows.topCheckBox.push({page_number:action.payload[3],isChecked:true,limit:action.payload[2]});
                //     }
                // }
                // else{
                //     foundObject.isChecked = false
                // }
                //     function distributeStudentIds(arrayOfObjects, limit,first_id) {
                        
                //         let first_stuid=parseInt(first_id.slice(-4))
                //         const numberOfPages = Math.ceil(arrayOfObjects.length / limit);
                //         const studentsPerPage = limit
                //         let tempcount=0
                //         let currentPage = 1;
                //         let studentsAssigned = 0;
                //         let studentrem=0
                //         arrayOfObjects.forEach((obj) => {
                //             if (studentsAssigned === parseInt(studentsPerPage)) {
                //                 const foundObj=state.selectedRows.topCheckBox.find((obj) => obj.page_number === currentPage.toString());
                //                 //const tempcount=state.selectedRows.studentId.filter(student => student.pageNumber === currentPage.toString()).length

                //                 if(!foundObj && tempcount===parseInt(studentsPerPage)){
                //                     state.selectedRows.topCheckBox.push({page_number:currentPage.toString(), isChecked:true,limit:limit });
                //                 }
                //                 else if(!foundObj && tempcount!==parseInt(studentsPerPage)){
                //                     state.selectedRows.topCheckBox.push({page_number:currentPage.toString(), isChecked:false,limit:limit })
                //                 } 
                //                 if(foundObj && tempcount===parseInt(studentsPerPage)){
                //                     foundObj.isChecked=true
                //                     foundObj.limit=limit
                //                 }
                //                 else if(foundObj && tempcount!==parseInt(studentsPerPage )){
                //                     foundObj.isChecked=false
                //                     foundObj.limit=limit
                //                 }
                //                 currentPage++;
                //                 studentsAssigned = 0;
                //                 tempcount=0
                //             }
                //             // obj.pageNumber = currentPage.toString();
                //             tempcount++
                //             if(parseInt(obj?.id?.slice(-4))===first_stuid){
                //                 first_stuid++;
                //                 studentsAssigned++
                //             }
                //             else{
                //                 while(true){
                //                     if(parseInt(obj?.id?.slice(-4))!==first_stuid){
                //                         if (studentsAssigned === parseInt(studentsPerPage)) {
                //                             currentPage++
                //                             studentsAssigned=1
                //                         }
                //                         studentsAssigned++;
                //                         first_stuid++
                //                     }
                //                     else{
                //                         studentsAssigned++
                //                         first_stuid++
                //                         break;
                //                     }
                                
                //                 }
                //             }
                //             obj.pageNumber = currentPage.toString();
                        
                        
                  
                        
                //         });
                //         if(!state.selectedRows.topCheckBox.some((obj)=>obj.page_number===currentPage.toString())){
                //             state.selectedRows.topCheckBox.push({page_number:currentPage.toString(), isChecked:false,limit:limit });

                //         }
                //         if(remstudentids>0){
                //             const lastStudentIds=state.selectedRows.studentId.filter((obj)=>obj.pageNumber===currentPage.toString())
                //             if(lastStudentIds.length===remstudentids){
                //                 const foundObj= state.selectedRows.topCheckBox.find((obj)=>obj.page_number===currentPage.toString())
                //                 if(foundObj){
                //                     foundObj.isChecked=true
                //                 }
                               
                //             }

                //         }
                //     }
                  
                //     distributeStudentIds(state.selectedRows.studentId,action.payload[2], action.payload[1]?.student_ids[0]);
                //     const objectWithHighestPageNumber = state.selectedRows.topCheckBox.reduce((maxObject, currentObject) => {
                //         return parseInt(currentObject.page_number) > parseInt(maxObject.page_number) ? currentObject : maxObject;
                //     }, state.selectedRows.topCheckBox[0]); 
                //     state.selectedRows.topCheckBox.forEach((obj1=>{
                //         const count = state.selectedRows.studentId.filter(obj2 => obj2.pageNumber === obj1.page_number).length;
                //         // Check if the count is equal to the limit
                //         if (count === limit && count<parseInt(action.payload[1].total_count)) {
                //             // Set isChecked to true for the corresponding object in the first array
                //             obj1.isChecked = true;
                //         }
                //         else if(count!==limit && count===(parseInt(action.payload[1].total_count)%limit)&&obj1.page_number===objectWithHighestPageNumber.page_number){
                //             obj1.isChecked=true
                //         }
                //         else{
                //             obj1.isChecked=false
                //         }
                //     }))
                
            }
           
        },
        resetState:(state)=>{
            state.selectedRows.studentId=[]
            state.selectedRows.topCheckBox=[]
        },
        addToTopCheckbox:(state,action)=>{
            const doesExist = state?.selectedRows?.topCheckBox?.some(obj => obj.page_number === action.payload[0].toString());

            if (!doesExist) {
                // If the item doesn't exist, add it to the array
                state.selectedRows.topCheckBox.push({"page_number":action.payload[0].toString(),isChecked:false,limit:action.payload[1]});
            }


        },
        limitReducer:(state,action,type)=>{
            const allExistMethod1 = action?.payload[0]?.data?.every((item2) =>
                state.selectedRows.studentId.some((item1) => item1.id === getAttendanceRowId(item2))
            )
            if(allExistMethod1){
                const doesExist = state?.selectedRows?.topCheckBox?.find(obj => obj.page_number === action.payload[2]);

                if (!doesExist) {
                // If the item doesn't exist, add it to the array
                    state.selectedRows.topCheckBox.push({"page_number":action.payload[0].toString(),isChecked:true,limit:action.payload[1]});
                }
                else{
                    doesExist.isChecked=true
                }

            }
            else{
                const doesExist = state?.selectedRows?.topCheckBox?.find(obj => obj.page_number === action.payload[2]);
                if(doesExist){
                    doesExist.isChecked=false
                }
                else{
                    state.selectedRows.topCheckBox.push({"page_number":action.payload[2],isChecked:false,limit:action.payload[1]});
                }
            }
            
        }
       
    
    },
});

export const { toggleRowSelection,selectAllStudents,resetState ,removeRow,addRow,onSearchRows,addToTopCheckbox,addData,limitReducer} = idSlice.actions;
export default idSlice.reducer;
